import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/pagination";
import SwiperCore from "swiper";
import styles from "./ImageProductSlider.module.css";

import { Navigation, Thumbs, Pagination } from "swiper/modules";

SwiperCore.use([Navigation, Thumbs, Pagination]);

const ImageProductSlider = ({ resultData, url, height }) => {
  const gallery = resultData || [];
  const hasMultipleImages = gallery.length > 1;

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const swiperRef = useRef(null);

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    swiperRef.current?.swiper?.slideTo(index);
  };
  return (
    <div
      className={`${styles.sliderRoot} ${height ? styles.hasGallery : ""} ${
        !hasMultipleImages ? styles.singleGallery : ""
      }`}
    >
      <div className={styles.mainSwiper}>
        {hasMultipleImages ? (
          <Swiper
            className={styles.imageProduct}
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
              height: "100%",
            }}
            spaceBetween={10}
            navigation={true}
            thumbs={{ swiper: thumbsSwiper }}
            onSlideChange={(swiper) => setSelectedImageIndex(swiper.activeIndex)}
            pagination={{
              clickable: true,
              renderBullet: function (index, className) {
                if (index < 4) {
                  return `<span class="${className}"></span>`;
                } else {
                  return "";
                }
              },
            }}
          >
            {gallery.map((image, index) => (
              <SwiperSlide key={image.link || index}>
                <img
                  src={url + image.link}
                  alt={`Product ${index + 1}`}
                  loading={index === 0 ? "eager" : "lazy"}
                  fetchPriority={index === 0 ? "high" : "auto"}
                  decoding="async"
                  sizes="(max-width: 767px) 84vw, 38vw"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className={`${styles.imageProduct} ${styles.singleImageProduct}`}>
            {gallery[0] && (
              <img
                src={url + gallery[0].link}
                alt="Product"
                className={styles.singleImage}
                loading="eager"
                fetchPriority="high"
                decoding="async"
                sizes="(max-width: 767px) 84vw, 38vw"
              />
            )}
          </div>
        )}
      </div>

      {hasMultipleImages && (
        <div className={styles.secondShowSwiper}>
          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={12}
            slidesPerView={4}
            freeMode={true}
            watchSlidesProgress={true}
            direction="vertical"
            breakpoints={{
              0: {
                direction: "horizontal",
                slidesPerView: "auto",
                centeredSlides: gallery.length < 4,
              },
              992: {
                direction: "vertical",
                slidesPerView: "auto",
                centeredSlides: false,
              },
            }}
            ref={swiperRef}
          >
            {gallery.map((image, index) => (
              <SwiperSlide
                key={image.link || index}
                className={`${styles.thumbSlide} ${
                  selectedImageIndex === index ? styles.activeThumb : ""
                }`}
              >
                <img
                  src={url + image.link}
                  alt={`Thumbnail ${index + 1}`}
                  onClick={() => handleImageClick(index)}
                  className={styles.thumbImage}
                  loading="lazy"
                  decoding="async"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
};
export default ImageProductSlider;
